export default __webpack_public_path__ + "static/media/logout.55b9405a.svg";